<template>
  <el-form-item :label="i18nt('designer.setting.showText')">
    <el-switch v-model="optionModel.showText"></el-switch>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"

  export default {
    name: "showText-editor",
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// showText-editor.vue?2ee21ee6